export default function all(iterable, predicate) {
    for (const item of iterable) {
        if (!predicate(item)) {
            return false;
        }
    }
    return true;
}
